import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { patchBodyOwnerUserInformationQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyOwnerUserInformation/patchBodyOwnerUserInformationQueryFunction';
import { BodyPersonalInformationOwnerType } from '@/modules/adjusterReportModules/Insurer-information/types/BodyOwnerType';

type MutationVariables = {
  id: string;
  formData: BodyPersonalInformationOwnerType;
};

export const patchBodyOwnerUserInformationQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  MutationVariables
> => ({
  mutationKey: ['patch-Body-user-Information'],
  mutationFn: ({ id, formData }: MutationVariables) =>
    patchBodyOwnerUserInformationQueryFunction(id, formData),
});
